import { qualityApiClient } from '@/shared/api/core/axios-instance';

import type { DataZone, DataZoneCountType } from '@/entities/quality/domain';

export type DataZoneRowCountApiResponse = {
  id: number;
  tableId: number;
  fqn: string;
  dataZone: DataZone;
  namespace: string;
  tableName: string;
  statDate: string;
  countType: string;
  rowCount: number;
  collectedAt: string;
};

export type DataZoneRowCountApiParams = {
  dataZone?: DataZone;
  countType?: DataZoneCountType;
  fromDate: string;
  toDate: string;
  tableId?: number;
};

export type ZoneSummary = {
  bronze: {
    totalRows: number;
    tableCount: number;
    ratio: number;
  };
  silver: {
    totalRows: number;
    tableCount: number;
    ratio: number;
  };
  gold: {
    totalRows: number;
    tableCount: number;
    ratio: number;
  };
};

export type DataZoneRowCountApiResult = {
  success: boolean;
  data: DataZoneRowCountApiResponse[];
  meta: {
    total: number;
    referenceDate: string;
    grandTotal: number;
  };
  summary: ZoneSummary;
};

export const getDataZoneRowCount = async (params: DataZoneRowCountApiParams): Promise<DataZoneRowCountApiResult> => {
  try {
    const { data } = await qualityApiClient.get<DataZoneRowCountApiResult>('/stats/row-counts', { params });
    return data;
  } catch (error) {
    console.error('Failed to fetch data zone row count:', error);
    throw error;
  }
};
